import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { CreateButton } from 'react-admin';
import { IconButton, iconButtonSx } from '../icon-button/IconButton';
import AddIcon from '@mui/icons-material/Add';

interface EmptyBoxProps {
  title: string;
  resource?: string;
  onClick?: () => void;
  description?: string;
  showCreate?: boolean;
}
export const EmptyBox: React.FC<EmptyBoxProps> = ({ title, description, resource, onClick, showCreate = true }) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="300px"
      textAlign="center"
      gap={2}
    >
      <Box>
        <Typography variant="h6" color="text.secondary" gutterBottom
          sx={{
            fontSize: 'var(--text-xl)',
          }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary"
          sx={{
            fontSize: 'var(--text-xs)',
          }}>
          {description}
        </Typography>
      </Box>
      {!showCreate ? null : !onClick ? (
        <CreateButton label={t('ra.action.create')} resource={resource || ''} sx={iconButtonSx()} />
      ) : (
        <IconButton label={t('common.create')} icon={<AddIcon />} onClick={onClick} />
      )}
    </Box>
  );
};
